module.exports = __webpack_public_path__ + "img/SH2D_300001.ddf525c9.png";